import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

// Feature flag, per environment.*.ts: idp.useV2Oidc.
// - false (default/safe): issuer = idp.issuer (the original v1 gateway path), and every
//   check below is exactly what it was before AZTENC-7036 - skipIssuerCheck/disablePKCE
//   true, requireHttps/strictDiscoveryDocumentValidation false, tokenEndpoint/userinfoEndpoint
//   hardcoded to the v1 /oauth2/... paths. This is the known-working pre-outage behaviour.
// - true: issuer = idp.issuerV2 (the canonical issuer declared by the IdP's own discovery
//   document), full OIDC validation enabled, endpoints populated from the discovery document.
//   Only flip this once a real browser login has been verified on that environment - the v1
//   and v2 discovery documents don't agree on the issuer, so mixing the two breaks login
//   (see the int outage after the first AZTENC-7036 merge).
const useV2Oidc = environment.idp.useV2Oidc === true;
const issuer = useV2Oidc ? environment.idp.issuerV2 : environment.idp.issuer;
const isSecureIssuer = issuer.startsWith('https://');
const v2Active = useV2Oidc && isSecureIssuer;

export const authCodeFlowConfig: AuthConfig = {
	issuer,
	redirectUri: `${window.location.origin}/authenticationcallback`,
	clientId: environment.idp.clientId,
	responseType: 'code',
	scope: 'openid',
	strictDiscoveryDocumentValidation: v2Active,
	// strictScopeValidation: true,
	disablePKCE: !v2Active,
	skipIssuerCheck: !v2Active,
	useSilentRefresh: false,
	// preserveRequestedRoute: true

	//silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
	// v1 fallback only: the discovery document populates tokenEndpoint/userinfoEndpoint
	// once useV2Oidc is on, and the v2 paths don't match this v1 /oauth2/... pattern.
	...(v2Active ? {} : {
		tokenEndpoint: `${issuer}/oauth2/token`,
		userinfoEndpoint: `${issuer}/oauth2/userinfo`,
	}),
	requireHttps: v2Active,
};

// Replaces angular-oauth2-oidc's showDebugInformation, which prints the raw token
// response (access/id/refresh token in clear) to the console. Logs only the safe,
// non-secret parts: who the token belongs to, when it was issued, when it expires.
export function logAuthTokenLifecycle(oAuthService: OAuthService): void {
	const claims: any = oAuthService.getIdentityClaims();
	const user = claims && 'sub' in claims ? claims['sub'] : 'unknown';
	const issuedAt = claims && 'iat' in claims ? new Date(claims['iat'] * 1000).toISOString() : 'unknown';
	const expiresAtMs = oAuthService.getAccessTokenExpiration();
	const expiresAt = expiresAtMs ? new Date(expiresAtMs).toISOString() : 'unknown';
	console.info(`[auth] token received - user=${user} issuedAt=${issuedAt} expiresAt=${expiresAt}`);
}
